require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-reaching-all-children-with-education-raceii.json") })
        }
      }, "path---en-us-project-reaching-all-children-with-education-raceii");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-reaching-all-children-with-education-raceii!./.cache/json/en-us-project-reaching-all-children-with-education-raceii.json
// module id = 556
// module chunks = 231608221292675